import { MiddlewareDtoImpl } from '../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../middlewareapiresponse';

export interface AddNameTuneResponse extends MiddlewareAPIResponse
{
}

export class AddNameTuneResponseDtoImpl extends MiddlewareDtoImpl implements AddNameTuneResponse
{
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/nametune/addnametuneresponse.tsx